import React from "react";
import propTypes from "prop-types";

import "./Button.css";

const Button = props => (
  <button
    className={`button ${props.className ? props.className : ""}`}
    type={props.type ? props.type : "button"}
    onClick={props.onClick}
  >
    {props.children && <span className={"button__text"}>{props.children}</span>}
    {props.icon && (
      // <img className={'button__icon'} src={props.icon} alt={'icon'} />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="22"
        viewBox="0 0 32 22"
        className={"button__icon"}
      >
        <path
          id="iconArrow.svg"
          className="button__close"
          d="M4087.35 549.432l-8.72-8.325H4107v-2.223h-28.37l8.72-8.324-1.65-1.573-10.71 10.222v1.573L4085.7 551z"
          transform="translate(-4075 -529)"
        />
      </svg>
    )}
  </button>
);

Button.propTypes = {
  onClick: propTypes.func.isRequired,
  className: propTypes.string,
  type: propTypes.string,
  icon: propTypes.string,
  children: propTypes.node.isRequired
};

export default Button;
